import { render, staticRenderFns } from "./endereco.vue?vue&type=template&id=565ec550&scoped=true"
import script from "./endereco.vue?vue&type=script&lang=js"
export * from "./endereco.vue?vue&type=script&lang=js"
import style0 from "./endereco.vue?vue&type=style&index=0&id=565ec550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565ec550",
  null
  
)

export default component.exports